<template>
    <detail-card v-if="customer"
                 type="customer"
                 :data="customer"
                 v-bind="$attrs">
        <template v-slot:header>{{ customer.name }}</template>
        <template v-slot:body>
            <prop name="#">{{ customer.number }}</prop>
            <prop name="Name">{{ customer.name }}</prop>
            <prop name="Firma" v-if="customer.company">{{ customer.company }}</prop>
            <prop name="Adresse">
                <div>{{ customer.streetAndNumber }}</div>
                <div>{{ customer.zip }}&nbsp;{{ customer.city }}</div>
            </prop>
            <prop name="Telefon"><a :href="'tel:' + customer.phone">{{ customer.phone }}</a></prop>
            <prop name="Email"><a :href="'mailto:' + customer.email">{{ customer.email }}</a></prop>
            <prop name="Anmerkungen">
                <div class="list-group small" v-if="annotations.length > 0">
                    <div v-for="a in annotations" :key="a.id" class="list-group-item p-2 d-flex">
                        <div class="list-inline-item" style="min-width: 14px;">
                            <font-awesome-icon v-if="a.positive || a.negative"
                                               :icon="a.positive ? 'check' : 'times'"
                                               :class="{'text-success': a.positive, 'text-danger': a.negative}"/>
                        </div>
                        <div class="list-inline-item flex-grow-1">
                            {{ a.annotation }}
                        </div>
                        <div class="mr-0">
                            <button class="btn btn-sm btn-danger" @click="deleteAnnotation(a.id)">
                                <font-awesome-icon icon="times"/>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-else>-</div>
                <div v-if="annotating" class="mt-2 form-group">
                    <div class="form-row">
                        <textarea class="form-control" v-model="editedAnnotation.annotation"/>
                    </div>
                    <div class="form-row pl-4">
                        <input type="checkbox" class="form-check-input" v-model="editedAnnotation.positive"/>positiv
                    </div>
                    <div class="form-row pl-4">
                        <input type="checkbox" class="form-check-input" v-model="editedAnnotation.negative"/>negativ
                    </div>
                    <div class="form-row float-right mt-1">
                        <button class="btn btn-sm btn-warning" @click="annotating = false">Abbrechen</button>
                        <button type="submit" class="btn btn-sm btn-success ml-1" @click="saveAnnotation">Speichern
                        </button>
                    </div>
                </div>
                <div v-else class="mt-2">
                    <button class="btn btn-primary btn-sm" @click="annotating = true">Neue Anmerkung</button>
                </div>
            </prop>
        </template>
    </detail-card>
</template>

<script>
import DetailCard from "@/layouts/DetailCard";
import Prop from "@/layouts/Prop";

export default {
    components: {DetailCard, Prop},
    props: {
        customer: Object,
    },
    data() {
        return {
            annotations: [],
            annotating: false,
            editedAnnotation: {}
        }
    },
    methods: {
        loadAnnotations() {
            this.$api.get('/annotations', {
                params: {
                    customer: this.customer.id
                }
            }).then(res => {
                this.annotations = res.data
                this.clearEditedAnnotation()
            }).catch(err => this.handleError(err))
        },
        saveAnnotation() {
            this.$api.put('/annotations', this.editedAnnotation)
                .then(() => this.loadAnnotations())
                .catch(err => this.handleError(err))
        },
        deleteAnnotation(annotationId) {
            this.$api.delete(`/annotations/${annotationId}`)
                .then(() => this.loadAnnotations())
                .catch(err => this.handleError(err))
        },
        clearEditedAnnotation() {
            this.editedAnnotation = {
                customer: this.customer,
                annotation: '',
                positive: false,
                negative: false
            }
        }
    },
    watch: {
        customer: {
            handler(newVal) {
                if (newVal?.id)
                    this.loadAnnotations()
            },
            immediate: true
        }
    }
}
</script>
